import { render } from "./FeedbackStepTwo.vue?vue&type=template&id=e0824338"
import script from "./FeedbackStepTwo.vue?vue&type=script&lang=js"
export * from "./FeedbackStepTwo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__